(() => {
  if (window.__bpcCartUnitPriceFixLoaded) return;
  window.__bpcCartUnitPriceFixLoaded = true;

  let queued = false;

  const parseUsd = (text) => {
    const cleaned = String(text || '').replace(/[^\d.,-]/g, '');
    if (!cleaned) return NaN;

    const lastDot = cleaned.lastIndexOf('.');
    const lastComma = cleaned.lastIndexOf(',');
    let normalized = cleaned;

    if (lastDot > -1 && lastComma > -1) {
      if (lastDot > lastComma) {
        normalized = cleaned.replace(/,/g, '');
      } else {
        normalized = cleaned.replace(/\./g, '').replace(',', '.');
      }
    } else if (lastComma > -1) {
      const decimals = cleaned.length - lastComma - 1;
      normalized = decimals === 2
        ? cleaned.replace(/\./g, '').replace(',', '.')
        : cleaned.replace(/,/g, '');
    } else {
      normalized = cleaned.replace(/,/g, '');
    }

    const value = Number(normalized);
    return Number.isFinite(value) ? value : NaN;
  };

  const getUsdCents = (priceElement) => {
    const stored = Number(priceElement.dataset.bpcCartUnitUsdCents);
    if (Number.isFinite(stored) && stored > 0) return Math.round(stored);

    const engineStored = Number(priceElement.dataset.bpcCartUsdCents);
    if (Number.isFinite(engineStored) && engineStored > 0) {
      priceElement.dataset.bpcCartUnitUsdCents = String(Math.round(engineStored));
      return Math.round(engineStored);
    }

    const source =
      priceElement.querySelector('.bpc-cart-price__usd')?.textContent ||
      priceElement.dataset.bpcOriginalUsdText ||
      priceElement.textContent;

    const value = parseUsd(source);
    if (!Number.isFinite(value) || value <= 0) return 0;

    const cents = Math.round(value * 100);
    priceElement.dataset.bpcCartUnitUsdCents = String(cents);
    return cents;
  };

  const renderUnitPrice = (details) => {
    const engine = window.BpcCurrency;
    if (!engine || engine.currency === 'USD' || typeof engine.toLocal !== 'function') return;

    const name = details.querySelector(':scope > .cart-item__name');
    if (!name) return;

    const discounted = details.querySelector(':scope > .cart-item__discounted-prices');
    const priceElement = discounted
      ? discounted.querySelector('.cart-item__final-price')
      : name.nextElementSibling;

    if (!priceElement) return;

    const engineLocal = priceElement.querySelector('.bpc-cart-price__local');
    if (engineLocal) {
      engineLocal.classList.add('bpc-cart-unit-local');
      return;
    }

    if (!priceElement.matches('.product-option, .cart-item__final-price')) return;

    const usdCents = getUsdCents(priceElement);
    if (!usdCents) return;

    const localValue = engine.toLocal(usdCents / 100);
    if (!Number.isFinite(localValue) || localValue <= 0) return;

    let local = priceElement.querySelector(':scope > .bpc-cart-unit-local');
    if (!local) {
      local = document.createElement('span');
      local.className = 'bpc-cart-unit-local';
      priceElement.appendChild(local);
    }

    local.textContent = `(approx. ${engine.formatLocal(localValue)})`;
  };

  const render = () => {
    document.querySelectorAll('.cart-item__details').forEach(renderUnitPrice);
  };

  const schedule = () => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        queued = false;
        render();
      });
    });
  };

  document.addEventListener('bpc:currency-ready', schedule);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', schedule, { once: true });
  } else {
    schedule();
  }

  new MutationObserver(schedule).observe(document.body, {
    childList: true,
    subtree: true
  });
})();
